import { IUsersWorkplace } from 'core/interfaces/userInterface';
import { apiService } from 'core/services/apiService';
import { User, UserMe } from 'types';
import { Participant } from './broadcast';

const GetUsersList = async (workplaceId: number): Promise<User[]> => {
	const { ...data } = apiService.responseHandler(
		await apiService.get(`users/${workplaceId}`)
	);
	return [data];
};

const GetUsersWorkplacesList = async (): Promise<IUsersWorkplace[]> => {
	const { ...data } = apiService.responseHandler(
		await apiService.get(`users/workplaces`)
	);
	return [data];
};

const GetParticipantsList = async (workplaceId: number): Promise<Participant[]> => {
	const { ...data } = apiService.responseHandler(
		await apiService.get(`users-workplaces/${workplaceId}`)
	);

	const participants: Array<Participant> = Object.values(data as Array<IUsersWorkplace>).map((user) => ({
		id: user.user.id,
		first_name: user.user.first_name.trim(),
		last_name: user.user.last_name.trim(),
		email: user.user.email || '',
	}));

	return participants;
};

const getUser = async (userId: number): Promise<UserMe> => {
	const { data } = apiService.responseHandler(await apiService.get(`users/${userId}`));
	return data;
};

export { GetParticipantsList, getUser, GetUsersList, GetUsersWorkplacesList };
